export default __webpack_public_path__ + "slices/main/assets/public/media/masthead/report-thumb@2x.fd8c4c2e718a3941fcc3483bf9404aee.png";